import { getLogLevel } from './env'
import pino from 'pino'

export interface Log {
  readonly error: (error: string) => void
  readonly info: (info: string) => void
  readonly debug: (debug: string) => void
}

function pinoLogger(): Log {
  const logger = pino({ level: getLogLevel() })

  function error(error: string): void {
    logger.error(error)
  }

  function info(info: string): void {
    logger.info(info)
  }

  function debug(debug: string): void {
    logger.debug(debug)
  }

  return Object.freeze({
    error,
    info,
    debug
  })
}

export const logger = pinoLogger()
